import { Component, Input, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalBaseDirective } from '$core/base/_modal.component';
import { TranslateService } from '@ngx-translate/core';
import { BatchMailing } from '../../models';

@Component({
  selector: 'app-edite-batch-departure-modal',
  templateUrl: './edite-batch-departure-modal.component.html',
  styleUrls: ['./edite-batch-departure-modal.component.scss'],
})
export class EditeBatchDepartureModalComponent
  extends ModalBaseDirective
  implements OnDestroy
{
  @Input() public batchDeparture: BatchMailing;

  constructor(
    protected modalRef: BsModalRef,
    protected modalService: BsModalService,
    protected translateService: TranslateService
  ) {
    super(modalRef, modalService, translateService);
  }

  public ngOnDestroy() {}
}
